<template>
  <base-material-card class="v-card--material-chart" v-bind="$attrs" v-on="$listeners">
    <GChart :type="chartType" :data="chartData" :options="chartOptions" />

    <slot />

    <slot slot="actions" name="actions" />
  </base-material-card>
</template>

<script>
export default {
  name: 'MaterialChartCard',
  inheritAttrs: false,
  props: {
    chartData: {
      type: Array,
      default: () => [],
    },
    eventHandlers: {
      type: Array,
      default: () => [],
    },
    chartOptions: {
      type: Object,
      default: () => ({}),
    },
    ratio: {
      type: String,
      default: undefined,
    },
    responsiveOptions: {
      type: Array,
      default: () => [],
    },
    chartType: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.v-card--material-chart {
  .v-card--material__header {
    padding: 2em 0;
  }
}
</style>
